import { Directive } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[monNoopValueAccessor]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: NoopValueAccessorDirective,
      multi: true,
    },
  ],
})
export class NoopValueAccessorDirective implements ControlValueAccessor {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public writeValue(_: unknown): void {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public registerOnChange(_: (_: unknown) => void): void {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public registerOnTouched(_: () => void): void {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public setDisabledState(_: boolean): void {
    return;
  }
}
